let updateTimeInterval;

const updateTime = () => {
  fetch('/dashboard/get_time')
    .then(data => {
      return data.text();
    })
    .then(data => {
      document.querySelector('.js-app-time').innerHTML = data;
    });
};

document.addEventListener('turbolinks:load', function () {
  if (document.querySelector('.js-app-time')) {
    // Update date and time at the top of the sidebar every 20 seconds
    updateTimeInterval = setInterval(updateTime, 20000);
  }
});

// setInterval is not torn down between Turbolinks page loads
// so it must be cleared manually with clearInterval()
document.addEventListener('turbolinks:before-render', function () {
  clearInterval(updateTimeInterval);
});
